import { render } from "./RTable.vue?vue&type=template&id=56bdc038"
import script from "./RTable.vue?vue&type=script&lang=js"
export * from "./RTable.vue?vue&type=script&lang=js"

import "./RTable.vue?vue&type=style&index=0&id=56bdc038&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__